// extracted by mini-css-extract-plugin
export default {"chevronColor":"#b5bac8","listItem":"style--listItem--cd8620","checkboxContainer":"style--checkboxContainer--b785e1","assignationsBadges":"style--assignationsBadges--9121f1"};